/* PERREOXL 2026 */
(function(){
  var d=document,root=d.documentElement;
  root.classList.add('pxl-js');

  /* header: solid after scroll */
  var nav=d.querySelector('.pxl-nav:not(.static)');
  function onScroll(){if(nav)nav.classList.toggle('solid',window.scrollY>40)}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();

  /* mobile drawer */
  var drawer=d.querySelector('.pxl-drawer');
  d.querySelectorAll('[data-pxl-open]').forEach(function(b){b.addEventListener('click',function(){drawer.classList.add('open');d.body.style.overflow='hidden';b.setAttribute('aria-expanded','true')})});
  function closeDrawer(){if(!drawer)return;drawer.classList.remove('open');d.body.style.overflow='';d.querySelectorAll('[data-pxl-open]').forEach(function(b){b.setAttribute('aria-expanded','false')})}
  d.querySelectorAll('[data-pxl-close], .pxl-drawer nav a').forEach(function(b){b.addEventListener('click',closeDrawer)});
  d.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();closeLb()}});

  /* hide events that already happened (client clock, in case the page is cached) */
  var today=new Date();var t=today.getFullYear()*10000+(today.getMonth()+1)*100+today.getDate();
  d.querySelectorAll('[data-pxl-date]').forEach(function(el){var v=parseInt(el.getAttribute('data-pxl-date'),10);if(v&&v<t)el.remove()});

  /* reveal */
  var rv=d.querySelectorAll('.pxl-rv');
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{rootMargin:'0px 0px -8% 0px'});
    rv.forEach(function(el){io.observe(el)});
  }else{rv.forEach(function(el){el.classList.add('in')})}

  /* counters */
  var cs=d.querySelectorAll('[data-pxl-count]');
  function fmt(v,dec){return dec?v.toFixed(dec):Math.round(v).toLocaleString('en-US')}
  function run(el){
    var to=parseFloat(el.getAttribute('data-pxl-count')),dec=(el.getAttribute('data-pxl-count').split('.')[1]||'').length,s=null,dur=1600;
    function step(ts){if(!s)s=ts;var p=Math.min((ts-s)/dur,1);p=1-Math.pow(1-p,3);el.textContent=fmt(to*p,dec);if(p<1)requestAnimationFrame(step)}
    requestAnimationFrame(step);
  }
  if('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches){
    var co=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){run(e.target);co.unobserve(e.target)}})},{threshold:.6});
    cs.forEach(function(el){co.observe(el)});
  }

  /* gallery lightbox */
  var lb=d.querySelector('.pxl-lb'),imgs=[],idx=0;
  function show(i){idx=(i+imgs.length)%imgs.length;lb.querySelector('img').src=imgs[idx].getAttribute('data-full');lb.querySelector('img').alt=imgs[idx].querySelector('img').alt||''}
  function closeLb(){if(lb){lb.classList.remove('open');d.body.style.overflow=''}}
  if(lb){
    imgs=[].slice.call(d.querySelectorAll('.pxl-gal button'));
    imgs.forEach(function(b,i){b.addEventListener('click',function(){show(i);lb.classList.add('open');d.body.style.overflow='hidden';lb.querySelector('.x').focus()})});
    lb.querySelector('.x').addEventListener('click',closeLb);
    lb.querySelector('.pv').addEventListener('click',function(){show(idx-1)});
    lb.querySelector('.nx').addEventListener('click',function(){show(idx+1)});
    lb.addEventListener('click',function(e){if(e.target===lb)closeLb()});
    d.addEventListener('keydown',function(e){if(!lb.classList.contains('open'))return;if(e.key==='ArrowLeft')show(idx-1);if(e.key==='ArrowRight')show(idx+1)});
  }
})();
